export default "__VITE_ASSET__Va47avYQ__"